import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import type { SchedulePrintListDay } from './schedulePrintModel';

type SchedulePrintMatchListProps = {
  day: SchedulePrintListDay;
};

export const SchedulePrintMatchList = memo(function SchedulePrintMatchList({
  day,
}: SchedulePrintMatchListProps) {
  const { t } = useTranslation();
  const prefix = 'creativeDetail-';

  return (
    <section
      className={`schedule-print-list-day${day.isFirstDay ? '' : ' schedule-print-day--page-break'}`}
    >
      <h2 className="schedule-print-day__title">
        {day.dayTitle}
        {day.dayDate ? (
          <span className="schedule-print-day__date"> — {day.dayDate}</span>
        ) : null}
      </h2>
      <table className="schedule-print-list-table">
        <thead>
          <tr>
            <th>{t(prefix + 'schedulePrintListStart')}</th>
            <th>{t(prefix + 'schedulePrintListEnd')}</th>
            <th>{t(prefix + 'schedulePrintCourtAxis')}</th>
            <th>{t(prefix + 'schedulePrintListGroupRound')}</th>
            <th>{t(prefix + 'schedulePrintListCategory')}</th>
            <th>{t(prefix + 'schedulePrintListTeam1')}</th>
            <th>{t(prefix + 'schedulePrintListTeam2')}</th>
            <th>{t(prefix + 'schedulePrintListMatchId')}</th>
          </tr>
        </thead>
        <tbody>
          {day.rows.map((row) => (
            <tr key={row.matchId}>
              <td>{row.startTime}</td>
              <td>{row.endTime}</td>
              <td>{row.court}</td>
              <td>{row.code}</td>
              <td>{row.className}</td>
              <td>{row.homeTeam}</td>
              <td>{row.awayTeam}</td>
              <td>{row.matchId}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
});
